import axios from "axios";

export const FETCH_ONBOARDING_STEPS_REQUEST = "FETCH_ONBOARDING_STEPS_REQUEST";
export const FETCH_ONBOARDING_STEPS_SUCCESS = "FETCH_ONBOARDING_STEPS_SUCCESS";
export const FETCH_ONBOARDING_STEPS_FAILURE = "FETCH_ONBOARDING_STEPS_FAILURE";

export const UPDATE_ONBOARDING_REVIEW_SETTINGS_REQUEST = "UPDATE_ONBOARDING_REVIEW_SETTINGS_REQUEST";
export const UPDATE_ONBOARDING_REVIEW_SETTINGS_SUCCESS = "UPDATE_ONBOARDING_REVIEW_SETTINGS_SUCCESS";
export const UPDATE_ONBOARDING_REVIEW_SETTINGS_FAILURE = "UPDATE_ONBOARDING_REVIEW_SETTINGS_FAILURE";

export const UPDATE_ONBOARDING_STEPS_REQUEST = "UPDATE_ONBOARDING_STEPS_REQUEST";
export const UPDATE_ONBOARDING_STEPS_SUCCESS = "UPDATE_ONBOARDING_STEPS_SUCCESS";
export const UPDATE_ONBOARDING_STEPS_FAILURE = "UPDATE_ONBOARDING_STEPS_FAILURE";

export const SET_ONBOARDING_STEPS_COMPLETE = "SET_ONBOARDING_STEPS_COMPLETE";

export const setOnboardingStepsComplete = () => ({
    type: SET_ONBOARDING_STEPS_COMPLETE
});

export const fetchOnBoardingStepsRequest = () => ({
    type: FETCH_ONBOARDING_STEPS_REQUEST
});

export const fetchOnBoardingStepsSuccess = data => ({
    type: FETCH_ONBOARDING_STEPS_SUCCESS,
    payload: data
});

export const fetchOnBoardingStepsFailure = error => ({
    type: FETCH_ONBOARDING_STEPS_FAILURE,
    error
});

export const fetchOnBoardingSteps = () => {
    return dispatch => {
        dispatch(fetchOnBoardingStepsRequest());
        axios.get("/get-onboarding-steps")
            .then(response => {
                dispatch(fetchOnBoardingStepsSuccess(response.data.onBoardingSteps));
            })
            .catch(error => {
                dispatch(fetchOnBoardingStepsFailure(error.message));
            });
    };
};

export const updateOnBoardingStepsRequest = () => ({
    type: UPDATE_ONBOARDING_STEPS_REQUEST
});

export const updateOnBoardingStepsSuccess = data => ({
    type: UPDATE_ONBOARDING_STEPS_SUCCESS,
    payload: data
});

export const updateOnBoardingStepsFailure = error => ({
    type: UPDATE_ONBOARDING_STEPS_FAILURE,
    error
});

export const updatehOnBoardingSteps = (data) => {
    return dispatch => {
        dispatch(updateOnBoardingStepsRequest());
        axios.post("/update-onboarding-steps", data)
            .then(response => {
                dispatch(updateOnBoardingStepsSuccess(response.data));
            })
            .catch(error => {
                dispatch(updateOnBoardingStepsFailure(error.message));
            });
    };
};

export const updateOnBoardingReviewSettingsRequest = () => ({
    type: UPDATE_ONBOARDING_REVIEW_SETTINGS_REQUEST
});


export const updateOnBoardingReviewSettingsSuccess = data => ({
    type: UPDATE_ONBOARDING_REVIEW_SETTINGS_SUCCESS,
    payload: data
});

export const updateOnBoardingReviewSettingsFailure = error => ({
    type: UPDATE_ONBOARDING_REVIEW_SETTINGS_FAILURE,
    error
});

export const updateOnBoardingReviewSettings = (data) => {
    return dispatch => {
        dispatch(updateOnBoardingReviewSettingsRequest());
        axios.post("/update-onboarding-review-settings", data)
            .then(response => {
                dispatch(updateOnBoardingReviewSettingsSuccess(response.data));
            })
            .catch(error => {
                dispatch(updateOnBoardingReviewSettingsFailure(error.message));
            });
    };
};